import { BreadcrumbContainer } from './AppBreadcrumb.styles';
import { Fragment, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { MENU_ITEMS } from '../menu-items';
import { ACTIONS_MENU_ITEMS } from 'app/layout/ActionsMenu/ActionsMenu';
import { nanoid } from 'nanoid';
import { AppIcon, AppIconName } from 'shared/icons/AppIcon';

type BreadcrumbOption = {
  icon: AppIconName;
  items: string[];
  path: string;
};

function buildBreadcrumbOptions(): BreadcrumbOption[] {
  const options: BreadcrumbOption[] = [];

  for (const section of MENU_ITEMS.sections) {
    for (const sectionItem of section.items) {
      if (sectionItem.items) {
        for (const subSectionItem of sectionItem.items) {
          options.push({
            items: [section.name, sectionItem.name, subSectionItem.name].filter(
              (item) => item,
            ),
            path: subSectionItem.path,
            icon: sectionItem.icon,
          });
        }
      } else {
        options.push({
          items: [section.name, sectionItem.name].filter((item) => item),
          path: sectionItem.path,
          icon: sectionItem.icon,
        });
      }
    }
  }

  // actions menu options
  for (const actionMenuItem of ACTIONS_MENU_ITEMS) {
    if (actionMenuItem.itemType === 'menuItem') {
      options.push({
        items: ['Opciones de usuario', actionMenuItem.text].filter((item) => item),
        path: actionMenuItem.path,
        icon: actionMenuItem.iconName,
      });
    }
  }

  return options;
}
const BREADCRUMB_OPTIONS = buildBreadcrumbOptions();

export const AppBreadcrumb = () => {
  const { pathname } = useLocation();
  const [data, setData] = useState<{
    icon: AppIconName;
    items: string[];
    lastItem: string;
  }>(null);

  useEffect(() => {
    const option = BREADCRUMB_OPTIONS.find((op) => op.path === pathname);
    if (option) {
      const items = [...option.items];
      const lastItem = items.pop();
      setData({
        items,
        lastItem,
        icon: option.icon,
      });
    } else {
      setData(null);
    }
  }, [pathname]);

  return (
    <>
      {data && (
        <BreadcrumbContainer>
          <div className="bc-container">
            <AppIcon className="main" name={data.icon} />
            <AppIcon name="ChevronRightIcon" />
            {data.items.map((item) => (
              <Fragment key={nanoid()}>
                <p>{item}</p>
                <AppIcon name="ChevronRightIcon" />
              </Fragment>
            ))}
            <p className="last">{data.lastItem}</p>
          </div>
        </BreadcrumbContainer>
      )}
    </>
  );
};
